import XRegExp from 'xregexp';
import * as zod from 'zod';

import { isValidLinkedin, LINKEDIN_ERROR_MESSAGE } from './linkedin';

const latinOnly = (message: string) =>
  zod
    .string()
    .min(2, { message })
    .refine(
      value =>
        XRegExp("^[\\p{Script=Latin}'~`^\\\\|{}[\\]\\-_\\s]*$").test(value),
      { message: "No symbols or digits please, it's not a nickname" }
    );

export const accountSchema = zod.object({
  firstName: latinOnly('Your full name goes here'),
  lastName: latinOnly('Your full surname goes here'),
  email: zod.string().email({ message: "Doesn't look like a valid email" }),
  country: zod.string().min(1, { message: 'Pick your country' }),
  linkedin: zod
    .string()
    .refine(isValidLinkedin, { message: LINKEDIN_ERROR_MESSAGE }),
  phone: zod
    .string()
    .optional()
    .refine(value => !value?.trim() || /^\+?[\d\s]+$/.test(value.trim()), {
      message: 'Numbers only please',
    }),
});

export type AccountFormValues = zod.infer<typeof accountSchema>;
